import { render, staticRenderFns } from "./WorkflowCaseAttachMgr.vue?vue&type=template&id=0095538e&scoped=true"
import script from "./WorkflowCaseAttachMgr.vue?vue&type=script&lang=js"
export * from "./WorkflowCaseAttachMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0095538e",
  null
  
)

export default component.exports